import Vue from 'vue';
import Router from 'vue-router';
import Root from './views/Root/Root.vue';

Vue.use(Router)

const vueRouter = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Root,
      redirect: '/index',
      meta: {
        title: '首页',
      },
      children: [
        {
          path: '/index',
          name: 'Index',
          component: () => import('./views/Index/Index.vue'),
          meta: {
            title: '首页',
          }
        },
        {
          path: '/setPwd',
          name: 'setPwd',
          component: () => import('./views/setPwd/setPwd.vue'),
          meta: {
            title: '修改密码',
          }
        }, 
        {
          path: '/DownData',
          name: 'DownData',
          component: () => import('./views/DownData/index.vue'),
          meta: {
            title: '企业财报',
          }
        },
        {
          path: '/FinanceInfo',
          name: 'FinanceInfo',
          component: () => import('./views/financeInfo/Index.vue'),
          meta: {
            title: '企业财报',
          }
        },
        {
          path: '/Earnings',
          name: 'Earnings',
          component: () => import('./views/financeInfo/Earnings/index.vue'),
          meta: {
            title: '估值报告',
          }
        }, 
        {
          path: '/Growth',
          name: 'Growth',
          component: () => import('./views/financeInfo/Growth/index.vue'),
          meta: {
            title: '增幅预估',
          }
        }, 
        {
          path: '/EveryDayInfo',
          name: 'EveryDayInfo',
          component: () => import('./views/financeInfo/EveryDayInfo/index.vue'),
          meta: {
            title: '当日行情详解',
          }
        }, 
        {
          path: '/Company',
          name: 'Company',
          component: () => import('./views/financeInfo/company/index.vue'),
          meta: {
            title: '企业资料',
          }
        }, 
      

      ]

    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('./views/Login/Login.vue'),
      meta: {
        title: '登录',
        isNoTab: true,
      }
    },  
  ]
});

vueRouter.beforeEach((to, from, next) => {
 /* 路由发生变化修改页面title */
 if (to.meta.title) {
  document.title = to.meta.title
}
  if (to.path != '/Login') {
    if (!localStorage.token) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }

});

export default vueRouter;